import http from "./http-common";

class QuestionGroupsService { 
  async getAll() {       
   const respons= await http.get(`QuestionGroups/GetByLanguageId`);    
    return respons
  }   
}

export default new QuestionGroupsService();